// extracted by mini-css-extract-plugin
export default {"nav":"HeadCenterTab_nav__VOmOz"};